import * as React from "react";
import { Label } from "components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";

type InputCouponTypeProps = {
  label?: string;
  value?: string;
  onChange?: (value: string | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
};

const OPTIONS = [
  { value: "65", label: "65 — NFC-e" },
  { value: "55", label: "55 — NF-e" },
  { value: "Both", label: "Ambos (55 + 65)" },
];

export default function InputCouponType({
  label = "Tipo do Cupom Fiscal",
  value,
  onChange,
  placeholder = "Selecionar tipo (55/65)",
  disabled,
  className,
}: InputCouponTypeProps) {
  const id = React.useId();

  return (
    <div className={`flex flex-col gap-2 ${className || ""}`}>
      {label && (
        <Label
          htmlFor={id}
          className="block text-sm font-medium text-gray-700"
        >
          {label}
        </Label>
      )}

      <Select value={value} onValueChange={(v) => onChange?.(v)} disabled={disabled}>
        <SelectTrigger
          id={id}
          className="flex items-center w-full h-8 px-3 border rounded-md text-left text-sm text-gray-700"
        >          
            <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        
        <SelectContent className="w-[--radix-select-trigger-width]">
          {OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value} className="text-gray-700">
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
